@if (!totalTable) {
  <p><strong>{{ "Tour price for various courses" | translate }}</strong></p>
}

@if (totalTable) {
  <div>
    <p><strong>{{ "Total tours prices" | translate }} </strong></p>
    <p class="selected-tours-count">
      <strong>
        {{ "Selected tours number" | translate }}- {{ shoppingService.shoppedTours.length }}
      </strong>
    </p>
  </div>
}

@if (settingsService.quotes) {
  @let rates = settingsService.quotes!.conversion_rates;

  <table>
    <tr>
      <th>{{ "Currency" | translate }}</th>
      <th>{{ "Price until 4 people" | translate }}</th>
      <th>{{ "Price from 5 until 7 people" | translate }}</th>
    </tr>
    <tr>
      <td>USD</td>
      <td>{{ math.floor(price * rates.USD) }}$</td>
      <td>{{ math.floor(groupPrice * rates.USD) }}$</td>
    </tr>

    <tr>
      <td>RUB</td>
      <td>{{ math.floor(price * rates.RUB) }}&#8381;</td>
      <td>{{ math.ceil(groupPrice * rates.RUB) }}&#8381;</td>
    </tr>

    <tr>
      <td>AMD</td>
      <td>{{ math.floor(price * rates.AMD) }}&#1423;</td>
      <td>{{ math.ceil(groupPrice * rates.AMD) }}&#1423;</td>
    </tr>
  </table>
}

